// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__m3tqc","search":"style_search__Y1jLq"};